import { Component } from '@theme/component';

class MTQHelpSearch extends Component {
  controller;
  connectedCallback() { super.connectedCallback();this.initialize(); }
  updatedCallback() { super.updatedCallback();this.initialize(); }
  disconnectedCallback() { super.disconnectedCallback();this.controller?.abort(); }
  initialize() {
    this.controller?.abort();this.controller = new AbortController();
    this.input = this.querySelector('[data-help-input]');
    this.status = this.querySelector('[data-help-status]');
    this.labels = JSON.parse(this.querySelector('[data-help-labels]')?.textContent || '{}');
    this.input?.addEventListener('input', this.filter, { signal: this.controller.signal });
    this.querySelector('form')?.addEventListener('submit', event => { event.preventDefault();this.filter(); }, { signal: this.controller.signal });
    this.filter();
  }
  filter = () => {
    const query = (this.input?.value || '').trim().toLocaleLowerCase();
    let count = 0;
    for (const item of this.querySelectorAll('[data-help-item]')) {
      const match = !query || item.textContent.toLocaleLowerCase().includes(query);
      item.hidden = !match;
      if (query) item.open = match;
      else item.open = false;
      if (match) count++;
    }
    for (const group of this.querySelectorAll('[data-help-group]')) group.hidden = !!query && ![...group.querySelectorAll('[data-help-item]')].some(item => !item.hidden);
    const topics = this.querySelector('.mtq-help-topics');if (topics) topics.hidden = !!query;
    if (this.status) this.status.textContent = query ? (this.labels.results || '').replace('__COUNT__', String(count)) : this.labels.browse || '';
    this.dataset.resultCount = String(count);
  };
}
if (!customElements.get('mtq-help-search')) customElements.define('mtq-help-search', MTQHelpSearch);
